export default __webpack_public_path__ + "static/works-kv-9ce58da0d50f84c3e016257c8d1b2b4f.png";